import css from './questionListFilters.module.scss';

import { memo } from 'react';

import { useQuestionEditor } from 'com/QuestionEditor';
import { getTestUrl } from 'core/paths';
import { useMessageModal } from 'core/ui/MessageModal';

import {
  AddQuestion,
  SearchInput,
  SearchButton,
  PlayButton,
  ToggleOptionsButton,
} from './Controls';
import { TSearchFilters } from './types';

type TProps = {
  fetchInitial: () => Promise<void>;
  test: TTest;
  addQuestion: (question: TQuestion) => void;
  filters: TSearchFilters;
  setFilter: <T extends keyof TSearchFilters>(
    key: T,
    value: TSearchFilters[T]
  ) => void;
  showOptions: boolean;
  onToggleOptions: () => void;
};

const QuestionListFilters = ({
  test,
  fetchInitial,
  addQuestion,
  filters,
  setFilter,
  showOptions,
  onToggleOptions,
}: TProps) => {
  const { createQuestion } = useQuestionEditor();
  const { showError } = useMessageModal();
  const onAddClick = () =>
    createQuestion(test.uid)
      .then(question => {
        if (question) addQuestion(question);
      })
      .catch(showError);

  return (
    <form
      className={css.filters}
      onSubmit={evt => {
        evt.preventDefault();
        void fetchInitial();
      }}
    >
      <SearchInput
        value={filters.text}
        onChange={text => setFilter('text', text)}
      />
      <SearchButton onClick={() => void fetchInitial()} />
      <AddQuestion onClick={() => void onAddClick()} />
      <PlayButton link={getTestUrl(test.uid)} />
      <ToggleOptionsButton active={showOptions} onClick={onToggleOptions} />
    </form>
  );
};

export default memo(QuestionListFilters);
